import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import PeopleIcon from "@mui/icons-material/People";

const CamAudienciaMiniCard = ({ data, cardLoader }) => {
  return (
    <div className="flex flex-col p-2 space-y-4 bg-white shadow-xl h-full w-full rounded-xl">
      <div className="flex items-center gap-2">
        <PeopleIcon fontSize="medium" />
        <h2 className="text-xl font-medium text-left font-Roboto">Audiencia</h2>
      </div>
      {cardLoader ? (
        <CircularProgress color="secondary" />
      ) : (
        <div className="flex items-center justify-center gap-3">
          <h3 className="text-3xl font-bold font-Roboto">
            {Number(data).toLocaleString()}
          </h3>
        </div>
      )}
    </div>
  );
};

export default CamAudienciaMiniCard;
